import React, { useEffect, useContext } from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import PageHeader from "../PageHeader";
import CycleFilter from "./CycleFilterv3";
import { PAGE_HEADERS } from "../util/Constants";
import RefreshTimer from "../RefreshTimer";
import { PVAOverviewContext } from "./context/PVAOverviewContext";
import { useDeviceLayout } from "../common/context/DeviceLayoutContext";
import { SMALL } from "../common/constant/BreakPoints";
import TVView from "../WIP/TVViewV2";
import { getRefreshInterval } from "./utils/utils";
import FPHView from "../FPH/FPHViewv2";
import { DEFAULT_CAPABILITIES } from "../outboundAmzl/util/Constants";
import ComplianceView from "../complaince/complianceViewv2";
import WIPView from "../WIP/WIPView";
import Responsive from "@amzn/meridian/responsive";
import { CapabilityContext } from "./context/CapabilityContext";
import { getNodeCapability } from "../handler/ParentDataHandler";
import HCView from "../HC/HCView";
import LinehaulsAtRiskView from "../linehaul/LinehaulsAtRiskView";
import FAView from "../WIP/FAView";
import ETAView from "../WIP/ETAView";
import ChartView from "../chart/ChartViewv2";

const OverviewView = (props) => {
  const { pvaData } = useContext(PVAOverviewContext);
  const { spacingInset_shorthand2 } = useDeviceLayout();

  return (
    <Column spacing={"none"}>
      <Row
        widths={["grid-6", "grid-6"]}
        wrap="down"
        alignmentVertical="stretch"
      >
        <PageHeader {...PAGE_HEADERS.OVERVIEW_V3} />
        <CycleFilter />
      </Row>
      <Row spacingInset={spacingInset_shorthand2}>
        <RefreshTimer deps={[pvaData]} />
      </Row>
      <ChartView
        breaksDataSources={props.breaksDataSources}
        view={{ processName: props.pva.processName }}
      />
      <SortStatistics {...props} />
    </Column>
  );
};

const SortStatistics = (props) => {
  const { capability, dispatch } = useContext(CapabilityContext);
  const { spacingInset_shorthand4 } = useDeviceLayout();

  useEffect(() => {
    getNodeCapability().then((capabilities) => {
      dispatch({ type: "GET_CAPABILITIES", capabilities });
    });
  }, []);

  return (
    <Column spacing="medium" spacingInset={spacingInset_shorthand4}>
      <Row width={"100%"} widths={["grid-12"]}>
        <Responsive
          query="max-width"
          props={{
            widths: {
              default: ["grid-4", "grid-4", "grid-4"],
              [SMALL]: ["100%", "100%", "100%"],
            },
          }}
        >
          {({ widths }) => (
            <Row widths={widths} wrap="down" alignmentVertical="stretch">
              <TVView
                tv={{
                  processName: "totalVolume",
                  refreshRate: getRefreshInterval(),
                }}
              />
              <ETAView
                eta={{
                  processName: "ETAToEndOfShift",
                  refreshRate: getRefreshInterval(),
                }}
              />
              {DEFAULT_CAPABILITIES.includes(capability.data) ? (
                <ComplianceView
                  compliance={{
                    processName: "scanCompliance",
                    refreshRate: getRefreshInterval(),
                  }}
                />
              ) : null}
            </Row>
          )}
        </Responsive>
      </Row>

      <Row width={"100%"} widths={["grid-12"]}>
        <Responsive
          query="max-width"
          props={{
            widths: {
              default: ["grid-3", "grid-3", "grid-3", "grid-3"],
              [SMALL]: ["100%", "100%", "100%", "100%"],
            },
          }}
        >
          {({ widths }) => (
            <Column>
              <Row widths={widths} wrap="down" alignmentVertical="stretch">
                <LinehaulsAtRiskView
                  linehaul={{
                    processName: "linehaulsAtRisk",
                    refreshRate: getRefreshInterval(),
                  }}
                />
                <FPHView
                  fph={{
                    processName: "induct",
                    refreshRate: getRefreshInterval(),
                  }}
                />
                <HCView
                  hc={{
                    processName: "induct",
                    refreshRate: getRefreshInterval(),
                  }}
                />
                <FAView
                  fa={{
                    processName: "flowAdherence",
                    refreshRate: getRefreshInterval(),
                  }}
                />
              </Row>
              <Row widths={widths} wrap="down">
                <WIPView
                  breaksDataSources={props.breaksDataSources}
                  wip={{
                    processName: "stowWip",
                    refreshRate: getRefreshInterval(),
                  }}
                />
                {DEFAULT_CAPABILITIES.includes(capability.data) ? (
                  <FPHView
                    fph={{
                      processName: "sort",
                      refreshRate: getRefreshInterval(),
                    }}
                  />
                ) : null}
                <HCView
                  hc={{
                    processName: "sort",
                    refreshRate: getRefreshInterval(),
                  }}
                />
                <WIPView
                  breaksDataSources={props.breaksDataSources}
                  wip={{
                    processName: "stowWipCompliance",
                    refreshRate: getRefreshInterval(),
                  }}
                />
              </Row>
            </Column>
          )}
        </Responsive>
      </Row>
    </Column>
  );
};

export default OverviewView;



// WEBPACK FOOTER //
// ./src/components/overview/OverviewViewv3.js